import { useEffect } from 'react';
import type { UseFormSetValue } from 'react-hook-form';
import type { AdditionalVehicleDetailsFormInputs } from '../schemas/additionalvehicledetails.schema';

/**
 * `shouldValidate` is required: clearing the orphan mileage alone leaves `isValid` false and
 * auto-save paused. Fires on mount too when seeded state carries a mileage with no date.
 */
export function useServiceHistoryPairing(
    lastServiceDate: Date | undefined,
    lastServiceMileage: number | undefined,
    setValue: UseFormSetValue<AdditionalVehicleDetailsFormInputs>,
): void {
    useEffect(() => {
        if (lastServiceDate === undefined && lastServiceMileage !== undefined) {
            setValue('lastServiceMileage', undefined, { shouldValidate: true, shouldDirty: true });
        }
    }, [lastServiceDate, lastServiceMileage, setValue]);
}
